import { AlternativeImage, ImageCheckType } from "Explore/Config/ImageType";
export const checkImageUrl = (url, setImage, type, altImg) => {
  const checkSingleImage = (imageUrl, onSuccess, onError) => {
    const image = new Image();
    image.onload = function () {
      if (this.width > 0) {
        onSuccess(imageUrl);
      } else {
        onError();
      }
    };
    image.onerror = onError;
    image.src = imageUrl;
  };

  const handleFallback = () => {
    if (type === ImageCheckType.CUSTOM && altImg) {
      checkSingleImage(
        altImg,
        (validAltImg) => setImage(validAltImg),
        () => setImage(AlternativeImage.CUSTOM)
      );
    } else {
      setImage(AlternativeImage[`${type}`]);
    }
  };

  if (url == null) {
    handleFallback();
    return;
  }

  checkSingleImage(url, (validUrl) => setImage(validUrl), handleFallback);
};
